import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './Profile.rules';

import Img from '../../../../components/Img';
import { graphql, useStaticQuery } from 'gatsby';

export type CaseStudies = 'kviff' | 'cme' | 'boxnow' |'iVysilani' | 'wwf'

export type ProfileProps = {
    image: string;
    caseId: CaseStudies;
    moduleName?: string;
};

const Profile = ({ image, caseId, moduleName }: ProfileProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    const images = useStaticQuery(graphql`
        query {
            allFile(filter: { relativeDirectory: { regex: "/references/case-studies/.*/" } }) {
                nodes {
                    base
                    relativePath
                    childImageSharp {
                        fluid(quality: 90, cropFocus: SOUTHWEST, maxWidth: 1520) {
                            ...GatsbyImageSharpFluid_withWebp_tracedSVG
                        }
                    }
                }
            }
        }
    `);

    const match = React.useMemo(
        () => images.allFile.nodes.find(({ relativePath }: { relativePath: string }) => { return image === relativePath}),
        [images, image],
    );

        const {
            childImageSharp: { fluid },
        } = match;
   
    return (
        <div className={styles.profile}>
            <Img
                style={{ transition: 'transform .4s ease', width: '3.125rem', height: '3.125rem' }}
                alt={`homepage.caseStudies.${caseId}.reference.content`}
                fluid={fluid}
            />

            <div>
                <span className={styles.nameText}>
                    {/* @ts-expect-error */}
                    {caseId ? <FormattedMessage id={`homepage.caseStudies.${caseId}.reference.author.name`} /> :null}
                </span>
                <span className={styles.positionText}>
                    {/* @ts-expect-error */}
                    {caseId ? <FormattedMessage id={`homepage.caseStudies.${caseId}.reference.author.position`} /> : null }
                </span>
            </div>
        </div>
    );
};

export default Profile;
